
import CustomersListTypesense from "./CustomersListTypesense";




export default function Customers() {

  return (
    <main style={{ padding: "1rem 0" }}>
      {

        // !userClaims["kfh_rm"] ?
        <CustomersListTypesense />
        // :
        // <CustomersFirebaseListSearch />
      }
    </main>
  );
}
